
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13448',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13448",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1077",
  "client-types": "static-1.507",
  "data-fetching-client": "static-1.10079",
  "foundations-components": "static-1.8685",
  "foundations-components-legacy": "static-1.1710",
  "foundations-theming": "static-1.4922",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.93",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8473",
  "hub-http-shared-msw-handlers": "static-1.10840",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11929",
  "I18n": "static-7.1700",
  "jasmine-runner": "static-1.6886",
  "marketplace-discovery-studio-lib": "static-1.843",
  "marketplace-storefront-base": "static-1.13511",
  "quartz": "static-1.7615",
  "react-dlb": "static-1.93",
  "react-rhumb": "static-1.17171",
  "reactive-variable-buffer-atom": "static-1.3288",
  "reporting-testing-lib": "static-1.11179",
  "reselect": "static-3.16",
  "settings-ui-lib": "static-1.12966",
  "SharedI18nStrings": "static-1.187",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7794",
  "ui-addon-i18n": "static-1.11581",
  "ui-addon-react-router-dom": "static-1.9963",
  "unified-auth": "static-1.1170",
  "unified-auth-core-lib": "static-1.1452",
  "usage-tracker": "static-1.7749",
  "usage-tracker-core": "static-1.7599",
  "customer-data-property-utils": "static-1.8483",
  "hub-http": "static-1.6645",
  "integrations-lib": "static-1.17333",
  "marketplace-ui-common": "static-1.20987",
  "marketplace-ui-install": "static-1.973",
  "property-management-iframe": "static-1.14385",
  "quartz-config": "static-1.1393",
  "quartz-core": "static-1.6834",
  "quartz-routing": "static-1.1045",
  "quick-fetch": "static-1.4206",
  "react": "static-7.202",
  "rpc-client-utils": "static-1.5108",
  "ts-schema": "static-1.4376",
  "ui-universal-auth": "static-1.9656",
  "UIComponents": "static-3.8875",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3892",
  "quartz-webpack": "static-1.3839",
  "bend-plugin-quartz-routing": "static-1.693",
  "ai-components-ui-library": "static-1.9953",
  "codemirror": "static-5.106",
  "foundations-assets": "static-1.5322",
  "pulse": "static-1.1078",
  "react-codemirror": "static-1.11076",
  "ui-extensions-preview-lib": "static-1.872",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4954",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2638",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9861",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.97",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5637",
  "react-virtualized": "static-2.111",
  "StyleGuideUI": "static-3.514",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.3001",
  "ui-fonts": "static-1.1191",
  "ui-images": "static-2.1270",
  "bend-plugin-foundations-theming": "static-1.3405",
  "foundations-theming-base": "static-1.3907",
  "stylex": "static-1.46",
  "HeadJS": "static-2.817",
  "hs-test-utils-bend-plugin": "static-1.3584",
  "msw": "static-1.102",
  "msw-config": "static-1.25",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4744",
  "ui-addon-video-player": "static-1.9061",
  "ai-rendering-library": "static-1.11335",
  "chirp-fetch": "static-1.2338",
  "connections-embed-lib": "static-1.1687",
  "copilot-toolkit": "static-1.12079",
  "feedback-loader": "static-1.30001",
  "laboratory-lib": "static-3.7587",
  "marketplace-embed": "static-1.23136",
  "marketplace-ui-details": "static-1.10882",
  "marketplace-ui-reviews": "static-1.20942",
  "marketplace-ui-tracking": "static-1.15157",
  "sanitize-text": "static-1.8592",
  "usage-tracker-multi": "static-1.6163",
  "usage-tracker-session-replay": "static-1.5435",
  "wootric-nps": "static-1.7276",
  "quartz-head": "static-1.1280",
  "web-vitals": "static-1.19",
  "apollo-link-hub-http": "static-2.5023",
  "immer": "static-1.105",
  "immerable": "static-1.4577",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2800",
  "reporting-data": "static-1.69246",
  "cssUtils": "static-1.1057",
  "flux-actions": "static-1.380",
  "react-colorpicker": "static-2.10648",
  "react-dnd-compat": "static-1.5046",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10806",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7739",
  "icons": "static-2.700",
  "marketplace-ui-apps-core": "static-1.19519",
  "storybook-react": "static-1.44",
  "trellis-story-utils": "static-1.4937",
  "foundations-components-test-utils": "static-1.6168",
  "quartz-i18n": "static-1.1290",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.700",
  "ads-unified-auth-lib": "static-1.1829",
  "custom-vendor-connection-lib": "static-1.220",
  "google-sheets-integration-lib": "static-1.1266",
  "microsoft-drive-auth-lib": "static-1.426",
  "slack-ui-library": "static-1.10835",
  "surveymonkey-integration-lib": "static-1.795",
  "fsm": "static-1.4194",
  "customer-data-objects": "static-1.8129",
  "property-translator": "static-1.5816",
  "hs-locale-management": "static-1.376",
  "frontend-preferences-client": "static-1.8355",
  "hs-promise-utils": "static-1.6028",
  "hubspot-apollo-client": "static-1.5315",
  "integrations-error-boundary-lib": "static-1.14748",
  "integrations-tracking-lib": "static-1.6050",
  "native-integrations-shared-strings": "static-1.8200",
  "sanitize": "static-1.4911",
  "superstore": "static-1.5194",
  "ui-shepherd-react": "static-3.10712",
  "ai-settings-ui-library": "static-1.8523",
  "hub-http-janus": "static-1.903",
  "hubspotter-http": "static-1.4950",
  "immutable-less": "static-1.5088",
  "marketplace-ui-client-types": "static-1.18394",
  "nav-meta": "static-1.30730",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18526",
  "ui-product-approvals-common": "static-1.1484",
  "ai-studio-lib": "static-1.12692",
  "hubspot-prosemirror": "static-1.19215",
  "integrations-reconnect-lib": "static-1.660",
  "ui-addon-iframeable": "static-1.9512",
  "ui-addon-integrations-directory-panel": "static-2.8390",
  "ui-product-approvals": "static-1.29589",
  "ui-tool-access": "static-1.10593",
  "inbound-db-properties-service-client": "static-1.4126",
  "property-management-common": "static-1.6673",
  "opentelemetry-fe-types": "static-1.226",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.601",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.601",
  "quartz-auth": "static-1.1290",
  "quartz-test": "static-1.1290",
  "quartz-tracking": "static-1.994",
  "trellis-components": "static-1.3020",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.518",
  "HubStyle": "static-2.12236",
  "bender-build-tools": "static-1.3518",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23616",
  "ContentUtils": "static-1.69391",
  "customer-data-objects-ui-components": "static-1.13465",
  "sassPrefix": "static-1.325",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.1984",
  "bend-plugin-pulse": "static-1.581",
  "event-emitter": "static-1.1397",
  "fast-json-patch": "static-1.74",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5874",
  "magpie-types": "static-1.5334",
  "stylex-utils": "static-1.168",
  "trellis-theming": "static-1.1424",
  "avatar-components": "static-1.2921",
  "breeze-engine-core": "static-1.1326",
  "breeze-onboarding-components": "static-1.996",
  "customer-data-filters-ui": "static-1.41269",
  "customer-data-reference-ui-components": "static-1.13603",
  "data-integrations-breeze": "static-1.240",
  "embedded-academy-lib": "static-1.15913",
  "ExportDialog": "static-6.10807",
  "global-styles-ai-lib": "static-1.427",
  "highlight.js": "static-1.90",
  "marketplace-embed-ba": "static-1.839",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.44",
  "reporting-action-components": "static-1.42310",
  "reporting-snowflake": "static-1.57862",
  "reporting-ui-components": "static-2.66515",
  "reporting-visualizations": "static-1.61320",
  "trial-components-library": "static-1.14317",
  "ui-addon-teams": "static-1.21972",
  "upgrade-components-lib": "static-1.677",
  "navigation-components": "static-1.19093",
  "breeze-engine-lib": "static-1.2048",
  "simple-logging-lib": "static-1.3489",
  "nudge-client-utils": "static-1.3355",
  "fail-safe": "static-1.387",
  "app-governance-lib": "static-1.2627",
  "developer-experience-shared-components": "static-1.10975",
  "purchase-motions-components": "static-1.6585",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10671",
  "usage-tracker-anonymous": "static-1.6166",
  "usage-tracker-public": "static-1.7560",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3754",
  "persist-promise": "static-1.4141",
  "reference-resolvers": "static-1.8616",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4353",
  "hubspot-apollo-cache": "static-1.774",
  "universal-page-editor-lib": "static-1.3444",
  "final-form": "static-1.82",
  "redux-toolkit": "static-1.82",
  "simple-data-table": "static-1.3762",
  "merchandise-lib": "static-1.283",
  "onboarding-scopes": "static-1.6889",
  "ui-addon-draggable": "static-3.5184",
  "content-assistance-lib": "static-1.8367",
  "content-media-capture": "static-1.5717",
  "customer-data-ui-utilities": "static-1.10269",
  "emoji-mart": "static-3.6",
  "file-manager-components": "static-1.24773",
  "growth-payments-core": "static-1.26434",
  "knowledge-content-types": "static-1.8723",
  "PatternValidationJS": "static-1.3322",
  "payment-link-components": "static-1.24376",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20494",
  "ui-addon-emoji-picker": "static-1.10301",
  "ui-business-units-lib": "static-1.9532",
  "video-components-external": "static-1.12365",
  "video-data-lib": "static-1.36023",
  "navigation-messaging": "static-1.8420",
  "collaboration-sidebar": "static-1.58983",
  "trellis-ext-dnd": "static-1.483",
  "crm-component-utils": "static-1.40103",
  "crm-properties-common-lib": "static-1.6326",
  "customer-data-properties": "static-1.52942",
  "external-options-client-types": "static-1.4425",
  "framework-data-schema-resolvers": "static-1.7330",
  "property-value-citations": "static-1.3556",
  "reference-resolvers-lite": "static-1.8543",
  "opentelemetry-web": "static-1.22",
  "beacon-keepalive-queue": "static-1.137",
  "hubspotter-http-shared-msw-handlers": "static-1.10838",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "cms-field-types": "static-1.5249",
  "content-icons-ui": "static-1.2420",
  "atom": "static-1.5514",
  "idb-keyval": "static-1.55",
  "reactive-lib": "static-1.1160",
  "breeze-artifacts-sdk": "static-1.765",
  "getting-started-shared-tasks": "static-1.19497",
  "onboarding-journeys-lib": "static-1.1170",
  "conversations-skeleton-state": "static-1.7603",
  "crm-message-bus": "static-1.44027",
  "customer-data-filters-ui-msw-helpers": "static-1.23704",
  "events-data-lib": "static-1.682",
  "FormUrlGenerator": "static-2.5152",
  "framework-builder-read-service-client": "static-1.4308",
  "hs-resources": "static-1.634",
  "multi-account-reference-resolvers": "static-1.1440",
  "onboarding-tours": "static-1.17341",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14704",
  "segments-client-types": "static-1.12045",
  "academy-common-lib": "static-1.15373",
  "dashboard-lib": "static-1.83211",
  "hubspot-prosemirror-plugins": "static-1.19207",
  "share-with-third-party-component-lib": "static-1.9148",
  "ui-asset-management-lib": "static-1.11540",
  "user-context": "static-1.5490",
  "reporting-plugins": "static-1.10919",
  "reporting-reports": "static-1.68922",
  "hubs-service-types": "static-1.1701",
  "purchase-motions-api": "static-1.6588",
  "salesImages": "static-1.692",
  "signup-constants": "static-1.19870",
  "nest": "static-1.671",
  "breeze-engine-chat-components": "static-1.1026",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.3112",
  "nudge-renderer-utils": "static-1.3431",
  "whisper-core-api": "static-1.7576",
  "bend-plugin-fail-safe": "static-1.338",
  "framework-listing-lib": "static-2.29737",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31685",
  "apps-service-types": "static-1.4083",
  "oauth-service-types": "static-1.4597",
  "signup-ui-url-generator": "static-2.8494",
  "onboarding-tours-client": "static-1.5556",
  "one-click-checkout": "static-1.692",
  "platform-infra-nav-components": "static-1.7979",
  "subscription-experience-data-types": "static-1.15390",
  "crm-record-cards-service-types": "static-1.3849",
  "location-customization-utils-lib": "static-1.10353",
  "redux-thunk": "static-2.84",
  "react-flip-move": "static-1.82",
  "ui-coaching-tips": "static-1.29536",
  "content-media-composition-data-lib": "static-1.13521",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4863",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3911",
  "seat-types-lib": "static-1.979",
  "ui-addon-opt": "static-4.8822",
  "commerce-tours-lib": "static-1.6805",
  "growth-onboarding-reliability": "static-1.5518",
  "sales-checkout-service-client": "static-1.3960",
  "data-token-picker": "static-1.17071",
  "FileManagerLib": "static-1.40413",
  "content-media-compositions": "static-2.17528",
  "media-bridge-lib": "static-1.19586",
  "chatspot-widget-iframe": "static-1.23607",
  "collaboration-sidebar-common": "static-1.3780",
  "marketing-platform-lib": "static-1.7331",
  "dnd-kit": "static-1.20",
  "card-properties-lib": "static-1.45263",
  "commerce-subscription-lib": "static-1.38027",
  "crm-actions": "static-1.6787",
  "crm-cards-sdk": "static-1.44919",
  "customer-data-properties-shared-msw-handlers": "static-1.10167",
  "customer-data-tracking": "static-1.7308",
  "trellis-migration-context": "static-1.15",
  "calling-global-api": "static-1.66079",
  "calling-internal-common": "static-1.31761",
  "calling-lifecycle-internal": "static-1.67461",
  "calling-lifecycle-messages": "static-1.59754",
  "commerce-products-lib": "static-1.10807",
  "conditional-properties-service-client": "static-1.4095",
  "crm-index-visualization-core": "static-1.4706",
  "crm-links": "static-1.6742",
  "crm-pipelines-api-client-types": "static-1.4427",
  "formula-editor": "static-1.14957",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4506",
  "meetings-icalendar-utils-lib": "static-1.1073",
  "multi-currency-client-types": "static-1.3991",
  "object-builder-ui-client": "static-1.49970",
  "pipeline-validation-client-types": "static-1.4264",
  "smart-data-capture-core": "static-1.404",
  "smart-property-lib": "static-1.8562",
  "tiered-pricing": "static-1.2170",
  "topics-actions-lib": "static-1.614",
  "trellis-ext-i18n": "static-1.1327",
  "ui-addon-form-validation": "static-1.11342",
  "zustand": "static-1.88",
  "fdsr-migration-layer": "static-1.449",
  "framework-data-schema-quick-fetch": "static-1.7235",
  "restore-request-side-panel-lib": "static-1.1954",
  "growth-data-modal": "static-1.6077",
  "growth-onboarding-confetti": "static-1.3498",
  "growth-onboarding-next-action-utils": "static-1.2921",
  "onboarding-tours-utils": "static-1.1408",
  "ui-shepherd-tracker": "static-1.8093",
  "crm-index-associations-lib": "static-1.6885",
  "academy-service-client": "static-1.4128",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40272",
  "SafeStorage": "static-1.4830",
  "video-embed": "static-1.36857",
  "redux-actions": "static-3.74",
  "EmailSignatureEditor": "static-1.25184",
  "viral-links-lib": "static-1.7515",
  "nested-table": "static-1.669",
  "timezone-utils": "static-2.5667",
  "getting-started-shared-tasks-store": "static-1.18615",
  "campaign-roi-lib": "static-1.10710",
  "campaigns-utils-lib": "static-1.3673",
  "ui-addon-calendars": "static-2.5799",
  "customer-data-views-management": "static-1.26267",
  "framework-data-table": "static-2.12779",
  "nudge-custom-ui-functions": "static-1.1685",
  "switchboard-lib": "static-1.663",
  "access-check-ui-lib": "static-1.1822",
  "app-users-service-client": "static-1.6056",
  "app-users-service-types": "static-1.5464",
  "mini-checkout-client": "static-1.27787",
  "onboarding-utils": "static-1.5809",
  "permissions-shared-i18n-strings-fe": "static-1.2142",
  "ui-coaching-tips-shared-config": "static-1.29521",
  "checkout-sdk": "static-3.24631",
  "payment-method-components": "static-1.7281",
  "touchless-buying-components": "static-1.6499",
  "upgrade-catalog-service-types": "static-1.3860",
  "edison-service-client-types": "static-1.828",
  "growth-onboarding-feedback-components": "static-1.7018",
  "audio-components": "static-1.6515",
  "FileManagerImages": "static-1.37924",
  "video-components": "static-1.14367",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.93130",
  "customer-data-sidebar": "static-2.46953",
  "enrichment-lib": "static-1.829",
  "smart-property-fill-lib": "static-1.580",
  "ui-addon-draggable-compat": "static-2.4699",
  "universal-record-utils-lib": "static-1.2286",
  "commerce-billing-lib": "static-1.20466",
  "commerce-shared-components-lib": "static-1.19499",
  "commerce-tools-ui-lib": "static-1.11259",
  "crm-fe-perf": "static-1.23333",
  "calling-error-reporting": "static-1.31768",
  "shared-worker-versioning": "static-1.11478",
  "calling-usage-tracker": "static-1.6970",
  "voice-sms-access-library": "static-1.2359",
  "commerce-permissions": "static-1.1218",
  "products-iframe-lib": "static-1.8834",
  "products-ui-components-shared-msw-handlers": "static-1.11222",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10923",
  "sales-views-client-types": "static-1.4693",
  "bark-lib": "static-1.16967",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.843",
  "data-agent-test-utils": "static-1.387",
  "data-agent-utils": "static-1.856",
  "policy-lib": "static-1.7245",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10986",
  "onboarding-data-sync-lib": "static-1.2781",
  "growth-onboarding-next-action-components": "static-1.2949",
  "user-context-client": "static-1.4945",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4951",
  "outpost": "static-1.4569",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22297",
  "sales-email-signature-service-client": "static-1.4286",
  "ts-utils-lib": "static-1.585",
  "copilot-messaging": "static-1.2329",
  "crm-export-dialog": "static-1.6712",
  "crm-index-ui-shimmer": "static-1.2914",
  "crm-view-components": "static-1.1434",
  "react-beautiful-dnd": "static-1.74",
  "customer-data-associations": "static-1.7770",
  "tasks-actions-lib": "static-1.372",
  "InboxConnectUtils": "static-4.15780",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.47077",
  "hub-http-rxjs": "static-1.872",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4425",
  "company-details-components": "static-1.6640",
  "react-performance-metrics-lib": "static-1.990",
  "pricing-pages-ui-components": "static-1.16391",
  "quote-checkout-service-types": "static-1.3892",
  "social-insights-client-types": "static-1.22871",
  "crm_universal": "static-1.22667",
  "customer-data-email": "static-1.18597",
  "card-payment-highlight-lib": "static-1.38240",
  "commerce-contract-lib": "static-1.13705",
  "invoices-highlight-card-lib": "static-1.56085",
  "orders-highlight-card-lib": "static-1.22438",
  "products-highlight-card-lib": "static-1.19090",
  "quotes-highlight-card-lib": "static-1.73026",
  "crm-source-interpretation-lib": "static-1.5762",
  "enrichment-settings-lib": "static-1.174",
  "data-agent-usage-based-billing": "static-1.31",
  "crm-object-search-query-utilities": "static-1.10401",
  "utility-belt": "static-1.2972",
  "payments-enrollment-embed-lib": "static-1.24130",
  "stripe-embedded-components": "static-1.8184",
  "customer-data-rte": "static-1.33837",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6472",
  "payments-post-enroll-local-storage-lib": "static-1.5539",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39116",
  "calling-orchestration-schema": "static-1.37136",
  "react-reducer-toolkit": "static-1.16603",
  "meetings-connect-utils-lib": "static-1.8053",
  "hub-http-contrib": "static-1.3465",
  "ui-addon-sales-email": "static-1.5639",
  "access-control-lib": "static-1.10864",
  "EmailComponents": "static-1.55785",
  "EmailData": "static-1.54463",
  "messaging-base-table-lib": "static-1.738",
  "redux-less": "static-2.9896",
  "company-details-service-types": "static-1.4380",
  "segments-query-core": "static-1.1866",
  "pricing-pages-api": "static-1.16256",
  "sequences-lib": "static-1.8712",
  "ui-gdpr-components": "static-1.10651",
  "products-ui-components": "static-1.41325",
  "reporting-enablement": "static-1.24098",
  "accounting-integrations-ui-components": "static-1.7738",
  "invoices-ui-lib": "static-1.56101",
  "commerce-products-api": "static-1.2864",
  "invoices-iframe-lib": "static-1.58159",
  "quotes-modal-lib": "static-1.103704",
  "quotes-ui-lib": "static-1.81747",
  "stripe-connect-js": "static-1.82",
  "draft-content-plugins": "static-1.29094",
  "ContentComponents": "static-2.72347",
  "ContentData": "static-1.69466",
  "marketing-email-service-types": "static-1.2195",
  "messaging-editing-lib": "static-1.47395",
  "messaging-usage-based-billing-components-lib": "static-1.2257",
  "automation-ui-source-apps": "static-1.19917",
  "automation-ui-types": "static-1.20835",
  "messaging-types-lib": "static-1.47132",
  "onboarding-settings-client": "static-1.4947",
  "sequences-client-types-lib": "static-1.8569",
  "commerce-tax-lib": "static-1.972",
  "price-books-api": "static-1.1974",
  "price-books-components": "static-1.2032",
  "property-description-translator": "static-1.4256",
  "ramp-editor": "static-1.1104",
  "data-quality-ui-library": "static-1.14198",
  "report-customization-components": "static-1.14144",
  "reporting-filters": "static-1.1229",
  "reporting-insights-lib": "static-1.2856",
  "commerce-analytics-service-client": "static-1.3948",
  "totals-ui-components": "static-1.24503",
  "SalesContentIndexUI": "static-3.9695",
  "advanced-menus-core": "static-1.15754",
  "advanced-menus-lib": "static-1.12517",
  "automation-ui-ubb": "static-1.6751",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7777",
  "data-token-views": "static-1.17052",
  "forms-utils-lib": "static-1.13277",
  "payments-embed-points-lib": "static-1.13789",
  "react-tinymce": "static-1.56205",
  "simple-menus-core": "static-1.15753",
  "simple-menus-lib": "static-1.17270",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55331",
  "tinymce-data": "static-1.41416",
  "tinymce-plugins": "static-1.58445",
  "tinymce-themes": "static-1.57301",
  "ui-brand-identity-lib": "static-1.16860",
  "ui-memberships-settings-lib": "static-1.35112",
  "videoconference-integration-components": "static-1.7473",
  "automation-applications-service-types": "static-1.3705",
  "automation-platform-service-types": "static-1.2716",
  "content-whatsapp-service-types": "static-1.661",
  "ContentEditorUI": "static-2.78166",
  "short-messages-app-service-client": "static-1.4363",
  "web-interactives-components": "static-1.14432",
  "web-interactives-data": "static-1.14433",
  "messaging-shared-utils-lib": "static-1.1706",
  "messaging-user-info-utils-lib": "static-1.1876",
  "email-portal-health-service-types": "static-1.1418",
  "line-items-api": "static-1.1273",
  "merge-modal-lib": "static-1.12954",
  "commerce-totals-service-types": "static-1.4114",
  "FireAlarmUi": "static-1.4822",
  "sales-templates-service-types-lib": "static-1.4466",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22771",
  "automation-ui-usage-tracking": "static-1.22234",
  "data-studio-ubb": "static-1.3748",
  "interframe": "static-3.5177",
  "layout-dnd-components": "static-1.13161",
  "layout-dnd-utils": "static-1.12136",
  "NamespacedHubStyle": "static-2.9343",
  "campaigns-lib": "static-1.27845",
  "content-management-data-lib": "static-1.6170",
  "copilot-plugins": "static-1.12051",
  "cta-picker": "static-1.37175",
  "customer-agent-discovery-components-lib": "static-1.4194",
  "editor-components": "static-1.13831",
  "editor-iframe-lib": "static-1.8955",
  "error-messaging-js": "static-1.5572",
  "FormsCommonComponents": "static-1.86773",
  "layout-data-lib": "static-1.10461",
  "pictos": "static-7.195",
  "react-transition-group": "static-2.77",
  "redux-request-state": "static-1.11076",
  "SharedLegalStrings": "static-1.2164",
  "smart-content-core": "static-1.43396",
  "smart-content-lib": "static-1.44049",
  "social-composer-lib": "static-1.60531",
  "structured-content-lib": "static-1.26131",
  "theme-previewer-lib": "static-1.54102",
  "tinymce-copilot": "static-1.17399",
  "xray-recommendation-lib": "static-1.8411",
  "automation-ui-routing": "static-1.22192",
  "sql-reporting-client-types": "static-1.5992",
  "attribution-lib": "static-1.42956",
  "voice-agents-components": "static-1.4011",
  "forms-ai-lib": "static-1.4926",
  "codemirror-dlb": "static-1.59725",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6881",
  "calling-orchestration-shared-library": "static-1.36911"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13448",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1077",
  "client-types": "/client-types/static-1.507",
  "data-fetching-client": "/data-fetching-client/static-1.10079",
  "foundations-components": "/foundations-components/static-1.8685",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1710",
  "foundations-theming": "/foundations-theming/static-1.4922",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.93",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8473",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10840",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11929",
  "I18n": "/I18n/static-7.1700",
  "jasmine-runner": "/jasmine-runner/static-1.6886",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.843",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13511",
  "quartz": "/quartz/static-1.7615",
  "react-dlb": "/react-dlb/static-1.93",
  "react-rhumb": "/react-rhumb/static-1.17171",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3288",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11179",
  "reselect": "/reselect/static-3.16",
  "settings-ui-lib": "/settings-ui-lib/static-1.12966",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7794",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11581",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9963",
  "unified-auth": "/unified-auth/static-1.1170",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1452",
  "usage-tracker": "/usage-tracker/static-1.7749",
  "usage-tracker-core": "/usage-tracker-core/static-1.7599",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8483",
  "hub-http": "/hub-http/static-1.6645",
  "integrations-lib": "/integrations-lib/static-1.17333",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20987",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.973",
  "property-management-iframe": "/property-management-iframe/static-1.14385",
  "quartz-config": "/quartz-config/static-1.1393",
  "quartz-core": "/quartz-core/static-1.6834",
  "quartz-routing": "/quartz-routing/static-1.1045",
  "quick-fetch": "/quick-fetch/static-1.4206",
  "react": "/react/static-7.202",
  "rpc-client-utils": "/rpc-client-utils/static-1.5108",
  "ts-schema": "/ts-schema/static-1.4376",
  "ui-universal-auth": "/ui-universal-auth/static-1.9656",
  "UIComponents": "/UIComponents/static-3.8875",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3892",
  "quartz-webpack": "/quartz-webpack/static-1.3839",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.693",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9953",
  "codemirror": "/codemirror/static-5.106",
  "foundations-assets": "/foundations-assets/static-1.5322",
  "pulse": "/pulse/static-1.1078",
  "react-codemirror": "/react-codemirror/static-1.11076",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.872",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4954",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2638",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9861",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.97",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5637",
  "react-virtualized": "/react-virtualized/static-2.111",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.3001",
  "ui-fonts": "/ui-fonts/static-1.1191",
  "ui-images": "/ui-images/static-2.1270",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3405",
  "foundations-theming-base": "/foundations-theming-base/static-1.3907",
  "stylex": "/stylex/static-1.46",
  "HeadJS": "/HeadJS/static-2.817",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3584",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.25",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4744",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9061",
  "ai-rendering-library": "/ai-rendering-library/static-1.11335",
  "chirp-fetch": "/chirp-fetch/static-1.2338",
  "connections-embed-lib": "/connections-embed-lib/static-1.1687",
  "copilot-toolkit": "/copilot-toolkit/static-1.12079",
  "feedback-loader": "/feedback-loader/static-1.30001",
  "laboratory-lib": "/laboratory-lib/static-3.7587",
  "marketplace-embed": "/marketplace-embed/static-1.23136",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10882",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20942",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15157",
  "sanitize-text": "/sanitize-text/static-1.8592",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6163",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5435",
  "wootric-nps": "/wootric-nps/static-1.7276",
  "quartz-head": "/quartz-head/static-1.1280",
  "web-vitals": "/web-vitals/static-1.19",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5023",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4577",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2800",
  "reporting-data": "/reporting-data/static-1.69246",
  "cssUtils": "/cssUtils/static-1.1057",
  "flux-actions": "/flux-actions/static-1.380",
  "react-colorpicker": "/react-colorpicker/static-2.10648",
  "react-dnd-compat": "/react-dnd-compat/static-1.5046",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10806",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7739",
  "icons": "/icons/static-2.700",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19519",
  "storybook-react": "/storybook-react/static-1.44",
  "trellis-story-utils": "/trellis-story-utils/static-1.4937",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6168",
  "quartz-i18n": "/quartz-i18n/static-1.1290",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.700",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1829",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.220",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1266",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.426",
  "slack-ui-library": "/slack-ui-library/static-1.10835",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.795",
  "fsm": "/fsm/static-1.4194",
  "customer-data-objects": "/customer-data-objects/static-1.8129",
  "property-translator": "/property-translator/static-1.5816",
  "hs-locale-management": "/hs-locale-management/static-1.376",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8355",
  "hs-promise-utils": "/hs-promise-utils/static-1.6028",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5315",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14748",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6050",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8200",
  "sanitize": "/sanitize/static-1.4911",
  "superstore": "/superstore/static-1.5194",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10712",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8523",
  "hub-http-janus": "/hub-http-janus/static-1.903",
  "hubspotter-http": "/hubspotter-http/static-1.4950",
  "immutable-less": "/immutable-less/static-1.5088",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18394",
  "nav-meta": "/nav-meta/static-1.30730",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18526",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1484",
  "ai-studio-lib": "/ai-studio-lib/static-1.12692",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19215",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.660",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9512",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8390",
  "ui-product-approvals": "/ui-product-approvals/static-1.29589",
  "ui-tool-access": "/ui-tool-access/static-1.10593",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4126",
  "property-management-common": "/property-management-common/static-1.6673",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.226",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.601",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.601",
  "quartz-auth": "/quartz-auth/static-1.1290",
  "quartz-test": "/quartz-test/static-1.1290",
  "quartz-tracking": "/quartz-tracking/static-1.994",
  "trellis-components": "/trellis-components/static-1.3020",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.518",
  "HubStyle": "/HubStyle/static-2.12236",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23616",
  "ContentUtils": "/ContentUtils/static-1.69391",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13465",
  "sassPrefix": "/sassPrefix/static-1.325",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.1984",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.581",
  "event-emitter": "/event-emitter/static-1.1397",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5874",
  "magpie-types": "/magpie-types/static-1.5334",
  "stylex-utils": "/stylex-utils/static-1.168",
  "trellis-theming": "/trellis-theming/static-1.1424",
  "avatar-components": "/avatar-components/static-1.2921",
  "breeze-engine-core": "/breeze-engine-core/static-1.1326",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.996",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41269",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13603",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.240",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15913",
  "ExportDialog": "/ExportDialog/static-6.10807",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.427",
  "highlight.js": "/highlight.js/static-1.90",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.839",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.44",
  "reporting-action-components": "/reporting-action-components/static-1.42310",
  "reporting-snowflake": "/reporting-snowflake/static-1.57862",
  "reporting-ui-components": "/reporting-ui-components/static-2.66515",
  "reporting-visualizations": "/reporting-visualizations/static-1.61320",
  "trial-components-library": "/trial-components-library/static-1.14317",
  "ui-addon-teams": "/ui-addon-teams/static-1.21972",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.677",
  "navigation-components": "/navigation-components/static-1.19093",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2048",
  "simple-logging-lib": "/simple-logging-lib/static-1.3489",
  "nudge-client-utils": "/nudge-client-utils/static-1.3355",
  "fail-safe": "/fail-safe/static-1.387",
  "app-governance-lib": "/app-governance-lib/static-1.2627",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10975",
  "purchase-motions-components": "/purchase-motions-components/static-1.6585",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10671",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6166",
  "usage-tracker-public": "/usage-tracker-public/static-1.7560",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3754",
  "persist-promise": "/persist-promise/static-1.4141",
  "reference-resolvers": "/reference-resolvers/static-1.8616",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4353",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.774",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3444",
  "final-form": "/final-form/static-1.82",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "simple-data-table": "/simple-data-table/static-1.3762",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "onboarding-scopes": "/onboarding-scopes/static-1.6889",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5184",
  "content-assistance-lib": "/content-assistance-lib/static-1.8367",
  "content-media-capture": "/content-media-capture/static-1.5717",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10269",
  "emoji-mart": "/emoji-mart/static-3.6",
  "file-manager-components": "/file-manager-components/static-1.24773",
  "growth-payments-core": "/growth-payments-core/static-1.26434",
  "knowledge-content-types": "/knowledge-content-types/static-1.8723",
  "PatternValidationJS": "/PatternValidationJS/static-1.3322",
  "payment-link-components": "/payment-link-components/static-1.24376",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20494",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10301",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9532",
  "video-components-external": "/video-components-external/static-1.12365",
  "video-data-lib": "/video-data-lib/static-1.36023",
  "navigation-messaging": "/navigation-messaging/static-1.8420",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58983",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.483",
  "crm-component-utils": "/crm-component-utils/static-1.40103",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6326",
  "customer-data-properties": "/customer-data-properties/static-1.52942",
  "external-options-client-types": "/external-options-client-types/static-1.4425",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7330",
  "property-value-citations": "/property-value-citations/static-1.3556",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8543",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.137",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10838",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "cms-field-types": "/cms-field-types/static-1.5249",
  "content-icons-ui": "/content-icons-ui/static-1.2420",
  "atom": "/atom/static-1.5514",
  "idb-keyval": "/idb-keyval/static-1.55",
  "reactive-lib": "/reactive-lib/static-1.1160",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.765",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19497",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1170",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7603",
  "crm-message-bus": "/crm-message-bus/static-1.44027",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23704",
  "events-data-lib": "/events-data-lib/static-1.682",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5152",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4308",
  "hs-resources": "/hs-resources/static-1.634",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1440",
  "onboarding-tours": "/onboarding-tours/static-1.17341",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14704",
  "segments-client-types": "/segments-client-types/static-1.12045",
  "academy-common-lib": "/academy-common-lib/static-1.15373",
  "dashboard-lib": "/dashboard-lib/static-1.83211",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19207",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9148",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11540",
  "user-context": "/user-context/static-1.5490",
  "reporting-plugins": "/reporting-plugins/static-1.10919",
  "reporting-reports": "/reporting-reports/static-1.68922",
  "hubs-service-types": "/hubs-service-types/static-1.1701",
  "purchase-motions-api": "/purchase-motions-api/static-1.6588",
  "salesImages": "/salesImages/static-1.692",
  "signup-constants": "/signup-constants/static-1.19870",
  "nest": "/nest/static-1.671",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1026",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3112",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3431",
  "whisper-core-api": "/whisper-core-api/static-1.7576",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.338",
  "framework-listing-lib": "/framework-listing-lib/static-2.29737",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31685",
  "apps-service-types": "/apps-service-types/static-1.4083",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8494",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5556",
  "one-click-checkout": "/one-click-checkout/static-1.692",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7979",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15390",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3849",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10353",
  "redux-thunk": "/redux-thunk/static-2.84",
  "react-flip-move": "/react-flip-move/static-1.82",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29536",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13521",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4863",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3911",
  "seat-types-lib": "/seat-types-lib/static-1.979",
  "ui-addon-opt": "/ui-addon-opt/static-4.8822",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6805",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5518",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3960",
  "data-token-picker": "/data-token-picker/static-1.17071",
  "FileManagerLib": "/FileManagerLib/static-1.40413",
  "content-media-compositions": "/content-media-compositions/static-2.17528",
  "media-bridge-lib": "/media-bridge-lib/static-1.19586",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23607",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3780",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7331",
  "dnd-kit": "/dnd-kit/static-1.20",
  "card-properties-lib": "/card-properties-lib/static-1.45263",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38027",
  "crm-actions": "/crm-actions/static-1.6787",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44919",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10167",
  "customer-data-tracking": "/customer-data-tracking/static-1.7308",
  "trellis-migration-context": "/trellis-migration-context/static-1.15",
  "calling-global-api": "/calling-global-api/static-1.66079",
  "calling-internal-common": "/calling-internal-common/static-1.31761",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67461",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59754",
  "commerce-products-lib": "/commerce-products-lib/static-1.10807",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4095",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4706",
  "crm-links": "/crm-links/static-1.6742",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4427",
  "formula-editor": "/formula-editor/static-1.14957",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4506",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1073",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3991",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49970",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4264",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.404",
  "smart-property-lib": "/smart-property-lib/static-1.8562",
  "tiered-pricing": "/tiered-pricing/static-1.2170",
  "topics-actions-lib": "/topics-actions-lib/static-1.614",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1327",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11342",
  "zustand": "/zustand/static-1.88",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.449",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7235",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1954",
  "growth-data-modal": "/growth-data-modal/static-1.6077",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3498",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2921",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1408",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8093",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6885",
  "academy-service-client": "/academy-service-client/static-1.4128",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40272",
  "SafeStorage": "/SafeStorage/static-1.4830",
  "video-embed": "/video-embed/static-1.36857",
  "redux-actions": "/redux-actions/static-3.74",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25184",
  "viral-links-lib": "/viral-links-lib/static-1.7515",
  "nested-table": "/nested-table/static-1.669",
  "timezone-utils": "/timezone-utils/static-2.5667",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18615",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10710",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3673",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5799",
  "customer-data-views-management": "/customer-data-views-management/static-1.26267",
  "framework-data-table": "/framework-data-table/static-2.12779",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1685",
  "switchboard-lib": "/switchboard-lib/static-1.663",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1822",
  "app-users-service-client": "/app-users-service-client/static-1.6056",
  "app-users-service-types": "/app-users-service-types/static-1.5464",
  "mini-checkout-client": "/mini-checkout-client/static-1.27787",
  "onboarding-utils": "/onboarding-utils/static-1.5809",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2142",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29521",
  "checkout-sdk": "/checkout-sdk/static-3.24631",
  "payment-method-components": "/payment-method-components/static-1.7281",
  "touchless-buying-components": "/touchless-buying-components/static-1.6499",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3860",
  "edison-service-client-types": "/edison-service-client-types/static-1.828",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7018",
  "audio-components": "/audio-components/static-1.6515",
  "FileManagerImages": "/FileManagerImages/static-1.37924",
  "video-components": "/video-components/static-1.14367",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.93130",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46953",
  "enrichment-lib": "/enrichment-lib/static-1.829",
  "smart-property-fill-lib": "/smart-property-fill-lib/static-1.580",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4699",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2286",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20466",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19499",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11259",
  "crm-fe-perf": "/crm-fe-perf/static-1.23333",
  "calling-error-reporting": "/calling-error-reporting/static-1.31768",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11478",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6970",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2359",
  "commerce-permissions": "/commerce-permissions/static-1.1218",
  "products-iframe-lib": "/products-iframe-lib/static-1.8834",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11222",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10923",
  "sales-views-client-types": "/sales-views-client-types/static-1.4693",
  "bark-lib": "/bark-lib/static-1.16967",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.843",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.387",
  "data-agent-utils": "/data-agent-utils/static-1.856",
  "policy-lib": "/policy-lib/static-1.7245",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10986",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2781",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2949",
  "user-context-client": "/user-context-client/static-1.4945",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4951",
  "outpost": "/outpost/static-1.4569",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22297",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4286",
  "ts-utils-lib": "/ts-utils-lib/static-1.585",
  "copilot-messaging": "/copilot-messaging/static-1.2329",
  "crm-export-dialog": "/crm-export-dialog/static-1.6712",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2914",
  "crm-view-components": "/crm-view-components/static-1.1434",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.74",
  "customer-data-associations": "/customer-data-associations/static-1.7770",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.372",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15780",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.47077",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.872",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4425",
  "company-details-components": "/company-details-components/static-1.6640",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.990",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16391",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3892",
  "social-insights-client-types": "/social-insights-client-types/static-1.22871",
  "crm_universal": "/crm_universal/static-1.22667",
  "customer-data-email": "/customer-data-email/static-1.18597",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38240",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13705",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.56085",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22438",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.19090",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.73026",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5762",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.174",
  "data-agent-usage-based-billing": "/data-agent-usage-based-billing/static-1.31",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10401",
  "utility-belt": "/utility-belt/static-1.2972",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24130",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8184",
  "customer-data-rte": "/customer-data-rte/static-1.33837",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6472",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5539",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39116",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37136",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16603",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8053",
  "hub-http-contrib": "/hub-http-contrib/static-1.3465",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5639",
  "access-control-lib": "/access-control-lib/static-1.10864",
  "EmailComponents": "/EmailComponents/static-1.55785",
  "EmailData": "/EmailData/static-1.54463",
  "messaging-base-table-lib": "/messaging-base-table-lib/static-1.738",
  "redux-less": "/redux-less/static-2.9896",
  "company-details-service-types": "/company-details-service-types/static-1.4380",
  "segments-query-core": "/segments-query-core/static-1.1866",
  "pricing-pages-api": "/pricing-pages-api/static-1.16256",
  "sequences-lib": "/sequences-lib/static-1.8712",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10651",
  "products-ui-components": "/products-ui-components/static-1.41325",
  "reporting-enablement": "/reporting-enablement/static-1.24098",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7738",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.56101",
  "commerce-products-api": "/commerce-products-api/static-1.2864",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.58159",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103704",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81747",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "draft-content-plugins": "/draft-content-plugins/static-1.29094",
  "ContentComponents": "/ContentComponents/static-2.72347",
  "ContentData": "/ContentData/static-1.69466",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2195",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47395",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2257",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19917",
  "automation-ui-types": "/automation-ui-types/static-1.20835",
  "messaging-types-lib": "/messaging-types-lib/static-1.47132",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4947",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8569",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.972",
  "price-books-api": "/price-books-api/static-1.1974",
  "price-books-components": "/price-books-components/static-1.2032",
  "property-description-translator": "/property-description-translator/static-1.4256",
  "ramp-editor": "/ramp-editor/static-1.1104",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.14198",
  "report-customization-components": "/report-customization-components/static-1.14144",
  "reporting-filters": "/reporting-filters/static-1.1229",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2856",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3948",
  "totals-ui-components": "/totals-ui-components/static-1.24503",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9695",
  "advanced-menus-core": "/advanced-menus-core/static-1.15754",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12517",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6751",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7777",
  "data-token-views": "/data-token-views/static-1.17052",
  "forms-utils-lib": "/forms-utils-lib/static-1.13277",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13789",
  "react-tinymce": "/react-tinymce/static-1.56205",
  "simple-menus-core": "/simple-menus-core/static-1.15753",
  "simple-menus-lib": "/simple-menus-lib/static-1.17270",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55331",
  "tinymce-data": "/tinymce-data/static-1.41416",
  "tinymce-plugins": "/tinymce-plugins/static-1.58445",
  "tinymce-themes": "/tinymce-themes/static-1.57301",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16860",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35112",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7473",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3705",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2716",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.661",
  "ContentEditorUI": "/ContentEditorUI/static-2.78166",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4363",
  "web-interactives-components": "/web-interactives-components/static-1.14432",
  "web-interactives-data": "/web-interactives-data/static-1.14433",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1706",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1876",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1418",
  "line-items-api": "/line-items-api/static-1.1273",
  "merge-modal-lib": "/merge-modal-lib/static-1.12954",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4114",
  "FireAlarmUi": "/FireAlarmUi/static-1.4822",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4466",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22771",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22234",
  "data-studio-ubb": "/data-studio-ubb/static-1.3748",
  "interframe": "/interframe/static-3.5177",
  "layout-dnd-components": "/layout-dnd-components/static-1.13161",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12136",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9343",
  "campaigns-lib": "/campaigns-lib/static-1.27845",
  "content-management-data-lib": "/content-management-data-lib/static-1.6170",
  "copilot-plugins": "/copilot-plugins/static-1.12051",
  "cta-picker": "/cta-picker/static-1.37175",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4194",
  "editor-components": "/editor-components/static-1.13831",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8955",
  "error-messaging-js": "/error-messaging-js/static-1.5572",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86773",
  "layout-data-lib": "/layout-data-lib/static-1.10461",
  "pictos": "/pictos/static-7.195",
  "react-transition-group": "/react-transition-group/static-2.77",
  "redux-request-state": "/redux-request-state/static-1.11076",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2164",
  "smart-content-core": "/smart-content-core/static-1.43396",
  "smart-content-lib": "/smart-content-lib/static-1.44049",
  "social-composer-lib": "/social-composer-lib/static-1.60531",
  "structured-content-lib": "/structured-content-lib/static-1.26131",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.54102",
  "tinymce-copilot": "/tinymce-copilot/static-1.17399",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8411",
  "automation-ui-routing": "/automation-ui-routing/static-1.22192",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5992",
  "attribution-lib": "/attribution-lib/static-1.42956",
  "voice-agents-components": "/voice-agents-components/static-1.4011",
  "forms-ai-lib": "/forms-ai-lib/static-1.4926",
  "codemirror-dlb": "/codemirror-dlb/static-1.59725",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6881",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.36911"
}
};
